import React, { ReactElement, useId } from 'react'
import cx from 'clsx'
import styles from './index.module.css'

export interface RadioButtonProps {
  checked: boolean
  title: string | ReactElement
  value: string
  name?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  className?: string
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  checked = true,
  value,
  title,
  name,
  onChange,
  disabled,
  className,
}) => {
  const id = useId()
  return (
    <div className={cx('flex items-center gap-2 w-full relative', className)}>
      <input
        className={cx(styles.radio)}
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {title}
      </label>
    </div>
  )
}

export default RadioButton
